document.addEventListener("DOMContentLoaded", () => {

  const STORAGE = "wishlist";
  const toast = document.getElementById("wishlistToast");
  const toastContent = document.querySelector(".wishlist-content");
  const closeBtn = document.getElementById("wishlistClose");
  const wishlistPageWrap = document.getElementById("library-products");

  let wishlist = JSON.parse(localStorage.getItem(STORAGE)) || [];

  /* ================= SAVE ================= */
  function save() {
    localStorage.setItem(STORAGE, JSON.stringify(wishlist));
    renderPopup();
    syncHearts();
    updateWishlistCount(); // 🔥 NEW
  }


  function exists(id) {
    return wishlist.some(p => p.id == id);
  }

  function updateWishlistCount() {
    const countEl = document.querySelector(".wishlist-count");
    if (!countEl) return;

    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const count = wishlist.length;

    if (count > 0) {
      countEl.textContent = count;
      countEl.style.display = "inline-block";
    } else {
      countEl.style.display = "none";
    }
  }

  /* ================= POPUP RENDER ================= */
  function renderPopup() {
    if (!toastContent) return;

    if (!wishlist.length) {
      toastContent.innerHTML = "<p>No items in wishlist</p>";
      return;
    }

    toastContent.innerHTML = wishlist.map(p => `
      <div class="toast-item">
        <a class="img" href="${p.url}">
          <img src="${p.img}" alt="${p.title}">
        </a>

        <div class="toast-info">
          <a href="${p.url}">${p.title}</a>
          <span>${p.price}</span>
        </div>

        <!-- HEART (remove) -->
        <button class="wishlist-btn popup-heart added" data-id="${p.id}">
          <i class="fas fa-heart"></i>
        </button>
      </div>
    `).join("");
  }

  /* ================= POPUP OPEN / CLOSE ================= */
  function openPopup() {
    if (!toast) return;
    toast.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  function closePopup() {
    toast?.classList.remove("show");
    document.body.style.overflow = "";
  }

  closeBtn?.addEventListener("click", closePopup);

  /* ================= HEART SYNC ================= */
  function syncHearts() {
    document.querySelectorAll(".wishlist-btn").forEach(btn => {
      const icon = btn.querySelector("i");
      const id = btn.dataset.id;

      if (!icon || !id) return;

      if (exists(id)) {
        btn.classList.add("added");
        icon.classList.remove("fal");
        icon.classList.add("fas");
      } else {
        btn.classList.remove("added");
        icon.classList.remove("fas");
        icon.classList.add("fal");
      }
    });
  }

  /* ================= HEART CLICK (GLOBAL) ================= */
  document.addEventListener("click", e => {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    e.preventDefault();

    const id = btn.dataset.id;
    if (!id) return;

    /* 🔥 animate ONLY clicked heart */
    btn.classList.add("animate");
    setTimeout(() => btn.classList.remove("animate"), 300);

    if (exists(id)) {
      wishlist = wishlist.filter(p => p.id != id);
    } else {
      wishlist.push({
        id,
        title: btn.dataset.title,
        img: btn.dataset.image,
        price: btn.dataset.price,
        url: btn.dataset.url
      });
      openPopup();
    }

    save();

    /* ================= REMOVE FROM WISHLIST PAGE ================= */
    if (wishlistPageWrap && !exists(id)) {
      const col = btn.closest(".col-lg-3, .col-md-4, .col-6");
      if (!col) return;

      col.style.transition = "all .3s ease";
      col.style.opacity = "0";
      col.style.transform = "scale(0.95)";

      setTimeout(() => {
        col.remove();
        if (!wishlistPageWrap.children.length) {
          wishlistPageWrap.innerHTML = "<p>No products in wishlist</p>";
        }
      }, 300);
    }
  });

  /* ================= INIT ================= */
  renderPopup();
  syncHearts();
  updateWishlistCount();

});